<!-- Moderator profile : view list of customers available to add credit-->
<!-- verify the role as Moderator -->
<ng-container *ngIf="role && role !== 'MODERATOR'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>
<mat-spinner class="comeOnTop" *ngIf="pdfLoading"></mat-spinner>
<ng-container *ngIf="role && role === 'MODERATOR'">
  <div class="wrapper">
    <br>
    <div class="content">
      <ng-container *ngIf="customers">
        <div class="alert alert-danger" role="alert" *ngIf="customers.length === 0">
          No Customers to add credti
        </div>
        <div class="alert alert-primary" role="alert" *ngIf="customers.length !== 0">
          Available customers to add credit
        </div>
        <!-- Customer details -->
        <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <th>User Name</th>
                  <th>Full Name</th>
                  <th>email</th>
                  <th>Contact Details</th>
                  <th>Action</th>
                  <!-- <th>Get Invoice</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let customer of customers">
                  <td>{{customer.userName}}</td>
                  <td>{{customer.fullName}}</td>
                  <td>{{customer.email}}</td>
                  <td>{{customer.contactNumber}}</td>
                  <td>
                    <button class="btn btn-lg btn-outline-primary" (click)="open(mymodal, customer, 1)">Add Credit</button>
                    <button class="btn btn-lg btn-outline-primary" (click)="open(mymodal1, customer, 2)">Update Charges</button>
                  </td>
                  <!-- <td>
                    <button class="btn btn-lg btn-outline-primary" type="button" [disabled]='pdfLoading' (click)="sendInvoice(customer._id, customer.fullName)">Get Invoice</button>
                  </td> -->

                </tr>
              </tbody>
              <!-- Facility to add credit or change rate -->
              <ng-template #mymodal let-modal>
                <div class="modal-header">
                  <div class="modal-title" id="modal-basic-title">Add Credit</div>
                  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <form (submit)="addCredit()" [formGroup]="creditForm">
                  <div class="modal-body">
                    <div id="left" class="cred">Credit:</div><input id="right" type="number" formControlName="creditToBeAdded"><br>
                    <mat-error *ngIf="creditForm.controls['creditToBeAdded'].invalid && creditForm.controls['creditToBeAdded'].errors.required"> Credit is Required </mat-error>
                    <br>


                    <div id="left" class="purpose" style="font-weight: 600">Purpose:</div>
                    <select  id="right" name="purpose" style="padding: 2px 5px;background-color: #fff;" formControlName="purpose" required>
				        <option value="Subscription">Subscription</option>
				        <option value="AMC">AMC</option>
				        <option value="Calibration">Calibration</option>
				        <option value="Initial_Deposit">Initial Deposit</option>
                    </select>
                    <mat-error *ngIf="creditForm.controls['purpose'].invalid && creditForm.controls['purpose'].errors.required"> Purpose is required  </mat-error>
                    <br>
                    <br>



                    <div id="left" class="cred">Payment Reference:</div><input id="right" type="text" formControlName="payment_reference" required><br>
                    <mat-error *ngIf="creditForm.controls['payment_reference'].invalid && creditForm.controls['payment_reference'].errors.required"> Payment Reference is required  </mat-error>
                    <br>
                    <br>
                    <div id="left" class="mode" style="font-weight: 600">Payment Mode:</div>
                    <select  id="right" name="mode" style="padding: 2px 5px;background-color: #fff;" formControlName="payment_mode" required>
                      <!-- <option value="">Select Payment mode</option> -->
              <option value="Online">Online</option>
              <option value="Cheque">Cheque</option>
              <option value="DD">DD</option>
              <option value="Swift">Swift</option>
                  </select>
                  <mat-error *ngIf="creditForm.controls['payment_mode'].invalid && creditForm.controls['payment_mode'].errors.required"> Payment mode is required  </mat-error>
                    <br>
                    <br>
                    <div id="left" class="cred">Date of Payment:</div><input id="right" type="date" formControlName="date_of_payment" required><br>
                    <mat-error *ngIf="creditForm.controls['date_of_payment'].invalid && creditForm.controls['date_of_payment'].errors.required"> Pyament date is required  </mat-error>
                    <br>
                    <br>
                    <div id="left" class="sum"> Summary:</div><textarea id="right" formControlName="summary"></textarea><br>
                    <mat-error *ngIf="creditForm.controls['summary'].invalid && creditForm.controls['summary'].errors.required"> Summary is Required </mat-error>
                  </div>
                  <br>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-outline-dark" [disabled]="creditForm.controls['summary'].invalid" (click)="modal.close('Save click')">Add credit</button>
                  </div>
                </form>
              </ng-template>

              <ng-template #mymodal1 let-modal>
                <div class="modal-header">
                  <h4 class="modal-title" id="modal-basic-title">Charges</h4>
                  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <form (submit)="addPaymentInfoCustomer()" [formGroup]="creditPerTransactionForm">
                  <div class="modal-body">
                    <div id="left" class="cred">Credit to be charged/transaction:</div><input id="right" type="number" formControlName="perTransactionCredit"><br><br>
                    <div id="left" class="cred">H/W Maintenance:</div><input id="right" type="number" formControlName="hw_maintenance"><br><br>
                    <div id="left" class="cred">Calibration:</div><input id="right" type="number" formControlName="calibration"><br><br>
                    <div id="left" class="cred">Annual Maintenance:</div><input id="right" type="number" formControlName="AMC"><br><br>
                    <div id="left" class="cred">Support Cost:</div><input id="right" type="number" formControlName="support"><br><br>
                    
                    <mat-error *ngIf="creditPerTransactionForm.controls['perTransactionCredit'].invalid && creditPerTransactionForm.controls['perTransactionCredit'].errors.required"> Credit is Required </mat-error>
                    <mat-error *ngIf="creditPerTransactionForm.controls['hw_maintenance'].invalid && creditPerTransactionForm.controls['hw_maintenance'].errors.required"> Hardware Maintenance is Required </mat-error>
                    <mat-error *ngIf="creditPerTransactionForm.controls['calibration'].invalid && creditPerTransactionForm.controls['calibration'].errors.required"> Calibration is Required </mat-error>
                    <mat-error *ngIf="creditPerTransactionForm.controls['AMC'].invalid && creditPerTransactionForm.controls['AMC'].errors.required"> Annual Maintenance is Required </mat-error>
                    <mat-error *ngIf="creditPerTransactionForm.controls['support'].invalid && creditPerTransactionForm.controls['support'].errors.required"> Support Cost is Required </mat-error>
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-outline-dark" [disabled]="creditPerTransactionForm.controls['perTransactionCredit'].invalid || creditPerTransactionForm.controls['hw_maintenance'].invalid || creditPerTransactionForm.controls['calibration'].invalid || creditPerTransactionForm.controls['AMC'].invalid || creditPerTransactionForm.controls['support'].invalid" (click)="modal.close('Save click')">Update</button>
                  </div>
                </form>
              </ng-template>
            </table>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="experts">
        <div class="alert alert-danger" role="alert" *ngIf="experts.length === 0">
          No experts to add credit
        </div>
        <div class="alert alert-primary" role="alert" *ngIf="experts.length !== 0">
          Available experts to add credit
        </div>
        <!-- Customer details -->
        <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <th>User Name</th>
                  <th>Full Name</th>
                  <th>email</th>
                  <th>Contact Details</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let expert of experts">
                  <td>{{expert.userName}}</td>
                  <td>{{expert.fullName}}</td>
                  <td>{{expert.email}}</td>
                  <td>{{expert.contactNumber}}</td>
                  <td>
                    <!-- <button class="btn btn-lg btn-outline-primary" (click)="open(mymodal, customer)">Add Credit</button> -->
                    <button class="btn btn-lg btn-outline-primary" (click)="openExpert(mymodal2, expert)">Change C/T</button>
                  </td>
                </tr>
              </tbody>
              <!-- Facility to add credit or change rate -->

              <ng-template #mymodal2 let-modal>
                <div class="modal-header">
                  <h4 class="modal-title" id="modal-basic-title">Change Credit Charged Per Transaction</h4>
                  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <form (submit)="addCreditPerTransactionExpert()" [formGroup]="creditPerTransactionFormExpert">
                  <div class="modal-body">
                    <div id="left" class="cred">Credit to be charged/transaction:</div><input id="right" type="number" formControlName="credit"><br>
                    <mat-error *ngIf="creditPerTransactionFormExpert.controls['credit'].invalid && creditPerTransactionFormExpert.controls['credit'].errors.required"> Credit is Required </mat-error>
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-outline-dark" [disabled]="creditPerTransactionFormExpert.controls['credit'].invalid" (click)="modal.close('Save click')">Update</button>
                  </div>
                </form>
              </ng-template>
            </table>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<!-- end of file -->
